import React from 'react'

interface MessageStepProps {
  message: string
  onMessageChange: (value: string) => void
}

const MessageStep: React.FC<MessageStepProps> = ({ message, onMessageChange }) => {
  return (
    <div>
      <p className="text-sm font-semibold text-foreground mb-3">Write your message</p>
      <textarea
        value={message}
        onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => onMessageChange(e.target.value)}
        placeholder="What did they do that deserves recognition? Be specific..."
        rows={5}
        className="flex w-full rounded-xl border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 resize-y leading-relaxed"
      />
    </div>
  )
}

export default MessageStep
